<template>
  <div id="detalle-recibo">
    <v-card class="v-card--material  pa-3">
      <v-card-title>Detalle pago</v-card-title>
      <v-row v-if="dataForm.registroDePagos !== undefined" justify="center">
        <v-col cols="12">
          <v-data-table :headers="headers" :items="listaPagos" disable-sort>
            <template v-if="$can('M_jugadores_edita')" v-slot:[`item.actions`]="{ item }">
              <v-tooltip content-class="top" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="anularPago(item)">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'DetalleRecibo',
    props: {
      listaPagos: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
    },
    data () {
      return {
        headers: [
          { text: 'Metodo de pago', align: 'start', value: 'metodopago.descripcion' },
          { text: 'Monto', value: 'montoACubrir' },
          { text: 'Deshacer', value: 'actions', sortable: false, align: 'end' },
        ],
        dataForm: {
          registroDePagos: [],
        },
      }
    },
    computed: {},
    created () {},
    methods: {
      anularPago (pago) {
        this.$emit('anularPago', pago)
      },
    },
  }
</script>
